// Filtres collants SNK (sections/snk-collection-filters.liquid). Les filtres restent ceux de Shopify (formulaire GET) :
// ce script ouvre un panneau à la fois, applique le tri dès qu'il change et, à chaque choix, redemande la section
// au serveur (Section Rendering API) pour mettre à jour « Voir N paires » et les tailles grisées avant l'envoi.
if (!customElements.get('snk-collection-filters')) {
  customElements.define(
    'snk-collection-filters',
    class SnkCollectionFilters extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.pills = [...this.querySelectorAll('[data-snk-pill]')];
        this.pills.forEach((pill) => pill.addEventListener('click', () => this.toggle(pill)));
        this.form.addEventListener('change', (event) => {
          if (event.target.matches('[data-snk-sort]')) this.form.requestSubmit();
          else if (event.target.matches('[data-snk-option]')) this.refresh();
        });
        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const open = this.pills.find((pill) => pill.getAttribute('aria-expanded') === 'true');
          if (open) {
            this.closeAll();
            open.focus();
          }
        });
        this.followAnnouncement();
      }

      toggle(pill) {
        const opening = pill.getAttribute('aria-expanded') !== 'true';
        this.closeAll();
        if (!opening) return;
        pill.setAttribute('aria-expanded', 'true');
        document.getElementById(pill.getAttribute('aria-controls')).hidden = false;
      }

      closeAll() {
        this.pills.forEach((pill) => {
          pill.setAttribute('aria-expanded', 'false');
          document.getElementById(pill.getAttribute('aria-controls')).hidden = true;
        });
      }

      // La barre colle juste sous la barre d'annonce, elle-même collante
      followAnnouncement() {
        const announcement = document.querySelector('.snk-announcement-section');
        if (!announcement) return;
        const update = () =>
          document.documentElement.style.setProperty('--snk-an-h', `${announcement.offsetHeight}px`);
        update();
        new ResizeObserver(update).observe(announcement);
      }

      async refresh() {
        const params = new URLSearchParams(new FormData(this.form));
        params.set('section_id', this.dataset.sectionId);
        this.controller?.abort();
        this.controller = new AbortController();
        let html;
        try {
          const response = await fetch(`${this.form.getAttribute('action')}?${params}`, {
            signal: this.controller.signal,
          });
          html = await response.text();
        } catch (error) {
          return;
        }
        const next = new DOMParser().parseFromString(html, 'text/html');

        // Chaque choix retrouve sa version à jour par son panneau et sa clé ; absent de la réponse (plus aucun modèle
        // en stock), il passe à 0 et grisé, sauf s'il est coché
        this.querySelectorAll('[data-snk-panel]').forEach((panel) => {
          const nextPanel = next.getElementById(panel.id);
          panel.querySelectorAll('[data-snk-option]').forEach((current) => {
            const input = nextPanel?.querySelector(`[data-snk-key="${CSS.escape(current.dataset.snkKey)}"]`);
            const count = current.parentElement.querySelector('[data-snk-option-count]');
            if (!input) {
              current.disabled = !current.checked;
              count.textContent = '0';
              return;
            }
            current.name = input.name;
            current.value = input.value;
            current.disabled = input.disabled && !current.checked;
            count.textContent = input.parentElement.querySelector('[data-snk-option-count]').textContent;
          });
        });

        const apply = next.querySelector('[data-snk-apply]');
        if (apply) this.querySelectorAll('[data-snk-apply]').forEach((button) => (button.textContent = apply.textContent));
      }
    }
  );
}
